import { useEffect, useRef, useState } from 'react';
import { useApp } from '../App.jsx';

// "Sign in with Google" (only shown when the server has it turned on)
export default function SignIn() {
  const { auth, api, checkAuth } = useApp();
  const button = useRef(null);
  const [error, setError] = useState(null);
  useEffect(() => {
    if (!auth.google) return undefined;
    let cancelled = false;
    const init = () => {
      if (cancelled || !window.google?.accounts?.id) return;
      window.google.accounts.id.initialize({
        client_id: auth.google,
        callback: async ({ credential }) => {
          try { await api.login(credential); setError(null); await checkAuth(); } catch (e) { setError(e.message); }
        },
      });
      if (button.current) window.google.accounts.id.renderButton(button.current, { theme: 'filled_black', size: 'large', shape: 'pill', text: 'signin_with' });
    };
    if (window.google?.accounts?.id) init();
    else {
      const s = document.createElement('script');
      s.src = 'https://accounts.google.com/gsi/client';
      s.async = true;
      s.onload = init;
      s.onerror = () => setError("Couldn't load Google sign-in. Check the connection.");
      document.head.appendChild(s);
    }
    return () => { cancelled = true; };
  }, [auth.google, api, checkAuth]);
  return (
    <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: 16 }}>
      <div className="card stack" style={{ maxWidth: 380, width: '100%', textAlign: 'center', alignItems: 'center', padding: 28 }}>
        <svg width="40" height="40" viewBox="0 0 32 32" aria-hidden="true"><rect width="32" height="32" rx="8" fill="#1e2024" /><path d="M8 20c0-4.4 3.6-8 8-8s8 3.6 8 8" fill="none" stroke="#3987e5" strokeWidth="3" strokeLinecap="round" /><circle cx="16" cy="20" r="3" fill="#3987e5" /></svg>
        <h1 style={{ fontSize: 20 }}>Joint Savings</h1>
        <p className="dim">Sign in with the Google account that was added to the app.</p>
        {window.location.protocol === 'http:' && !['localhost', '127.0.0.1'].includes(window.location.hostname) && (
          <p role="alert" style={{ color: 'var(--warn)' }}>Google only allows signing in on a secure (https) address. Open the app's https address instead of this one.</p>
        )}
        <div ref={button} />
        {error && <p role="alert" style={{ color: 'var(--danger)' }}>{error}</p>}
      </div>
    </div>
  );
}
